module.exports = __webpack_public_path__ + "static/media/20_B.c02e7dbb.png";